import posReducer from './reducers';

export { default as posOperations } from './operations';
export * from './types';

export default posReducer;
